import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ApmTranslatePipe } from '@mitsubishi/core';

import { FieldWrapper, FormlyField } from '@ngx-formly/core';

@Component({
  selector: 'apm-row-wrapper',
  templateUrl: './row-wrapper.component.html',
  styleUrls: ['./row-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ApmTranslatePipe, FormlyField],
})
export class RowWrapperComponent extends FieldWrapper {}
